import React from 'react'
import { PublicationSliderPlaceholder } from '../../components/PublicationSlider'

import { HeroSkeleton } from './CommunityHubPage.styles'

const CommunityHubPagePlaceholder = () => (
  <>
    <HeroSkeleton />
    <PublicationSliderPlaceholder />
  </>
)

export default CommunityHubPagePlaceholder
